import * as ACTION_TYPES from './Types';

const initialState = {
  orders:{},
  views:{},
  message: '',
  error: null,
}

export const ordersReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.GET_ORDERS_SUCCESS:  
      return {
          ...state,
          orders:action.payload.data,
          message: action.payload.message,
      }
    case ACTION_TYPES.VIEW_ORDER_SUCCESS:  
      return {
          ...state,
          views:action.payload.data,
          message: action.payload.message,
      }
    case ACTION_TYPES.GET_ORDERS_ERROR:
    case ACTION_TYPES.VIEW_ORDER_ERROR:    
      return {
        ...state,
        message: action.payload.message,
      }       
        
    default:
      return state;
  }
}
